import { useEffect, useState } from 'react';
import { nowSeconds } from '@/lib/format';

/**
 * How often the shared clock ticks by default.
 *
 * @since 1.3.0
 */
export const DEFAULT_TICK_MS = 60_000;

/**
 * Reads the current wire clock and re-renders the caller on a fixed interval, so relative
 * ages and receiving status stay current between refetches.
 *
 * @since 1.3.0
 * @param intervalMs - how often to tick, in milliseconds
 * @returns now, in whole seconds since the epoch
 */
export function useNow(intervalMs: number = DEFAULT_TICK_MS): number {
    const [now, setNow] = useState(nowSeconds);

    useEffect(() => {
        const timer = window.setInterval(() => setNow(nowSeconds()), intervalMs);

        return () => {
            window.clearInterval(timer);
        };
    }, [intervalMs]);

    return now;
}
